export enum Roles {
    USER = 'User',
    ADMIN = 'Admin',
    INVESTIGATOR = 'Investigator',
    FINANCE_MANAGER = 'Finance Manager',
    CREDIT_REVIEWER = 'Credit Reviewer',
    MANAGER = 'Manager',
    CSR = 'NAM CSR',
    REPORTING = 'Reporting'
}
